<template>
  <div class="menu">
    <!-- 运营商 -->
    <div v-if="!isEmptyObject(currentServiceProvider)" class="service-provider-container">
      <el-tooltip class="item" content="点击查看工作面板" placement="right-end">
        <router-link :to="`/dashboard`">
          <el-avatar :size="isMenuCollapse ? 35 : 45" :src="currentServiceProvider.logo_url"></el-avatar>

          <!-- 运营商名字，菜单展开才展示 -->
          <div v-if="!isMenuCollapse" class="sp-name lc-ellipsis-text" style="-webkit-line-clamp: 1">
            {{ currentServiceProvider.name }}
          </div>
        </router-link>
      </el-tooltip>
    </div>

    <!-- 菜单 -->
    <el-menu
      :default-active="activeMenu"
      class="el-menu-vertical"
      background-color="#333333"
      text-color="#fff"
      active-text-color="#43Cb83"
      :collapse="isMenuCollapse"
      :unique-opened="true"
      :router="false"
    >
      <el-submenu
        v-for="(item, index) in menuTree"
        v-show="canAccessMenus(item.children, permittedAuthCodes) && item.displayMenu"
        :key="index"
        :index="`m-${index}`"
      >
        <template slot="title">
          <i :class="item.icon"></i>
          <span>{{ item.name }}</span>
        </template>
        <div v-for="(child, i) in item.children" :key="i">
          <router-link :to="{ path: child.url, query: child.query }">
            <el-menu-item v-if="canAccess(child, child.authCode, permittedAuthCodes) && child.displayMenu" :index="child.url">
              {{ child.name }}
            </el-menu-item>
          </router-link>
        </div>
      </el-submenu>

      <!-- 全部功能 -->
      <!-- <el-menu-item style="" class="all-functions-menu-item" @click="emitDisplayAllFunctionsEvent">
        <i class="el-icon- lc-ico-menu-round lc-primary-color"></i>
        <span slot="title" class="all-functions-menu-item--text lc-primary-color">全部功能</span>
      </el-menu-item> -->
    </el-menu>
  </div>
</template>

<script>
import menuItems from '@/new_menu'
import MenuMixin from './menu_mixin'
import IdentificationMixin from '@/mixins/identification'

export default {
  mixins: [MenuMixin, IdentificationMixin],
  data() {
    return {
      drawer: true,
      menuTree: menuItems,
      selectMenuName: '',
      isCollapse: false,
      defaultActive: 'm-0-0'
    }
  },
  computed: {
    /**
     * 菜单是否收起
     *
     * @returns {boolean} 是否收起
     */
    isMenuCollapse() {
      // 直接读取 state
      return this.$store.state.menu.isCollapse
    },
    activeMenu() {
      const route = this.$route
      const { meta } = route
      // 如果设置了默认的激活菜单就显示默认的 如果无 就返回path
      if (meta.activeMenu) {
        return meta.activeMenu
      } else if (route.matched[0].path === '/management') {
        return route.matched[1].path
      }
      return route.matched[0].path
    }
  },
  methods: {
    /**
     * 展示全部功能
     */
    emitDisplayAllFunctionsEvent() {
      this.$emit('display-all-functions')
    }
  }
}
</script>
<style lang="scss" scoped>
.service-provider-container {
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;

  .sp-name {
    margin: 0 auto;
    margin-top: 5px;
    width: 110px;
    // height: 18px;
    color: #fff;
  }
}

.el-menu-vertical {
  border: none;
  min-height: 100%;
  overflow: hidden;
  &:not(.el-menu--collapse) {
    width: 150px;
  }

  // 子菜单（padding-left: 40px;）
  ::v-deep .el-submenu {
    &.is-opened {
      & > div {
        i {
          color: #ffffff;
        }
      }
    }
    .el-menu-item {
      // min-width: 159px;
      color: #b5b5b5 !important;
      font-size: 13px;
      height: 32px;
      line-height: 32px;
    }
  }

  // 主菜单（padding-left: 20px;）
  ::v-deep .el-submenu__title {
    height: 40px;
    line-height: 40px;
    font-size: 13px;
    i {
      font-size: 16px;
    }
  }
}

.all-functions-menu-item {
  i {
    font-size: 20px;
  }

  .all-functions-menu-item--text {
    font-weight: 600;
    vertical-align: baseline;
    font-size: 14px;
  }
}
</style>
